import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import styled from "styled-components";

const PagingTextWrapper = styled.div`
    font-size: 14px;
    font-weight: bold;
    color: #4b5563;
    margin-top:3px;
`;

export const pageSizeOptions = [10, 25, 50, 100];

export const pageOptions = {
    currentPage: 1,
    pageSize: pageSizeOptions[0],
}

const TablePagination = ({ pageSize, currentPage, totalPages, totalItems, onPageChange, onPageSizeChange, pageTitle }) => {
    let pageItemFrom = (currentPage <= 1 ? 1 : ((currentPage - 1) * pageSize) + 1);

    let pageItemTo = (pageSize * currentPage);
    pageItemTo = (pageItemTo > totalItems ? totalItems : pageItemTo);

    return (
        <>
            <Row className="m-0 mt-1">
                <Col>
                    <PagingTextWrapper className="pt-1">
                        Showing {pageItemFrom} to {pageItemTo} of {totalItems} {pageTitle}
                    </PagingTextWrapper>
                </Col>
                <Col className="text-center">
                    <ReactPaginate
                        containerClassName="pagination"
                        className="pagination"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        activeLinkClassName='active'
                        nextLabel=">"
                        previousLabel="<"
                        breakLabel="..."
                        // initialPage={(filters.currentPage - 1)}
                        forcePage={currentPage - 1}
                        onPageChange={onPageChange}
                        pageCount={totalPages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        renderOnZeroPageCount={null}
                    />
                </Col>
                <Col className="text-right">
                    <PagingTextWrapper>
                        Page Size
                        <select
                            className="p-1 ms-1"
                            value={pageSize}
                            onChange={onPageSizeChange}>
                            {pageSizeOptions.map((item, i) => <option value={item}>{item}</option>)}
                        </select>
                    </PagingTextWrapper>
                </Col>
            </Row>
        </>
    )
}

export default TablePagination;
